import { getLocale } from "../runtime";

const sv_productdetails = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Produktdetaljer`
};

const productdetails = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_productdetails(inputs)
	return "productDetails";
};

export { productdetails as "productDetails" };